
<template>
  <div class="count-icon">
    <div
      v-if="content.icon"
      class="count-icon__icon"
      :class="{'count-icon__icon--smaller': content.sizeSmall}"
    >
      <md-icon :md-src="'/static/images/icon-' + content.icon + '.svg'" />
    </div>
    <div
      class="count-icon__count"
      :class="{'count-icon__count--smaller': content.sizeSmall,
               'count-icon__count--bigger': content.sizeBig}"
    >
      <p :class="content.color">
        {{ content.number }}
      </p>
    </div>
    <div
      class="count-icon__description graphic"
      :class="{'count-icon__description--bigger': content.sizeBig}"
    >
      <h2>{{ content.text }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountIcon',
  props: {
    content: {
      icon: {
        type: String
      },
      number: {
        type: String
      },
      text: {
        type: String
      },
      color: {
        type: String
      },
      sizeSmall: {
        type: Boolean,
        default: false
      },
      sizeBig: {
        type: Boolean,
        default: false
      }
    }
  }
}
</script>
<style lang="scss">
.count-icon {
  display: flex;
  justify-items: center;
  flex-direction: row;
  margin-top: 1.6em;
  cursor: default;

  &__icon {
    width: 17%;
    text-align: center;

    .md-icon {
      padding: 2px;
      margin-top: 1px;
    }

    &--smaller {
      width: 12%;
    }
  }

  &__show-more {
    margin: auto;
    flex: 2;
    text-align: right;
    cursor: pointer;
  }

  &__count {
    min-width: 25%;
    padding-right: 10px;
    margin-bottom: 0.3em;

    &--smaller {
      min-width: 15%;

      p {
        text-align: center;
      }
    }

    &--bigger {
      min-width: 70%;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 26px;
    }
  }

  &__description {
    width: 30%;
    margin: auto 0;

    &--bigger {
      width: 70%;
    }

    h2 {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      display: flex;
      align-items: center;
      text-transform: uppercase;
      margin: auto;
      color: #7a7a7a;
    }
  }

  .orange {
    color: #f2994a;
  }

  .red {
    color: #e2245a;
  }

  .dark-orange {
    color: #ee5c53;
  }

  .morning-glory {
    color: #8AD4DF;
  }

  .light-blue {
    color: #2d9cdb;
  }
  .blue {
    color: #3cc2d9;
  }
  .yellow {
    color: #fe9c4b;
  }
  .green {
    color: #68edae;
  }
}
</style>
